import {
  AndroidOutlined,
  AppstoreOutlined,
  BarsOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  GlobalOutlined,
  LockOutlined,
  SlidersOutlined,
} from '@ant-design/icons-vue'
import { VNode, computed, h } from 'vue'
const VITE_SYSTEM_TYPE = import.meta.env.VITE_SYSTEM_TYPE as string
export interface MenuItem {
  icon?: VNode
  name: string
  key?: string
  routePath?: string
  activePattern?: RegExp
  children?: MenuItem[]
  isHide?: boolean
}

export const appConfig = {
  appName: '设备运维平台',
  appLinks: [] as { name: string; href: string }[],
}

const siteNameMap: Map<string, string> = new Map([
  ['production', '正式'],
  ['production-us', '美服正式'],
  ['test', '测试'],
  ['test-us', '美服测试'],
  ['debug', '调试'],
  ['development', '开发'],
])

export const AppName = computed(() => {
  return appConfig.appName + '（' + siteNameMap.get(VITE_SYSTEM_TYPE) + '）'
})

export const AppLinks = appConfig.appLinks || []

export const AppMenus: MenuItem[] = [
  {
    icon: h(AppstoreOutlined),
    name: '产品管理',
    key: 'product',
    children: [
      {
        name: '资源代号',
        routePath: '/search-product/index',
        activePattern: /^\/search-product/,
      },
      {
        name: '美服同步',
        routePath: '/product-sync/index',
        activePattern: /^\/product-sync/,
      },

      {
        name: '产品',
        routePath: '/product/index',
        activePattern: /^\/product\//,
      },
      {
        name: '固件',
        routePath: '/firmware/index',
        activePattern: /^\/firmware\//,
      },
      {
        name: '场景',
        routePath: '/scene/index',
        activePattern: /^\/scene/,
      },
    ],
  },
  {
    icon: h(DashboardOutlined),
    name: '看板展示',
    key: 'dashboard',
    children: [
      {
        name: '产品看板',
        routePath: '/product-dashboard/index',
        activePattern: /^\/product-dashboard\//,
      },
      {
        name: '固件看板',
        routePath: '/firmware-dashboard/index',
        activePattern: /^\/firmware-dashboard\//,
      },
      {
        name: 'OTA版本对比',
        routePath: '/dashboard/ota-compare',
        activePattern: /^\/dashboard\/ota-compare/,
      },
      {
        name: 'OTA/固件时间线',
        routePath: '/dashboard/release-timeline',
        activePattern: /^\/dashboard\/release-timeline/,
      },
    ],
  },
  {
    icon: h(DatabaseOutlined),
    name: '设备管理',
    key: 'device',
    children: [
      {
        name: '设备查询',
        routePath: '/device/search',
        activePattern: /^\/device\/search/,
      },
      {
        name: '设备列表',
        routePath: '/device/manage',
        activePattern: /^\/device\/manage/,
      },
    ],
  },
  {
    icon: h(AndroidOutlined),
    name: 'APP 管理',
    key: 'APP',
    isHide: true,
    children: [
      {
        name: 'APP',
        routePath: '/product/index',
        activePattern: /^\/apk/,
      },
    ],
  },
  {
    icon: h(GlobalOutlined),
    name: '文案翻译',
    key: 'i18n',
    children: [
      {
        name: '产品文案',
        routePath: '/i18n/product',
      },
      {
        name: '固件文案',
        routePath: '/i18n/firmware',
      },
      // {
      //   name: 'APP 文案',
      //   routePath: '/i18n/apk',
      // },
    ],
  },
  {
    icon: h(BarsOutlined),
    name: '升级记录',
    key: 'upgrad',
    children: [
      {
        name: 'X5平台',
        routePath: '/upgrad/x5grad',
      },
      {
        name: 'XOS平台',
        routePath: '/upgrad/xosgrad',
      },
    ],
  },
  {
    icon: h(SlidersOutlined),
    name: '审计',
    key: 'audit',
    children: [
      {
        name: 'OTA审批',
        routePath: '/audit/ota_approval',
      },
    ],
  },
  {
    icon: h(LockOutlined),
    name: '权限管理',
    key: 'iam',
    children: [
      {
        name: '成员与部门',
        routePath: '/iam/org',
      },
      {
        name: '角色与权限',
        routePath: '/iam/permission',
      },
    ],
  },
]

/**
 * 本固件对应权限字段
 */
export const AppPermissions = {
  //产品
  Product: ['view:product.product.product'],
  ProductManage: ['manage:product.product.product'],
  ProductAddManage: ['manage:product.product.product.add'],
  ProductDeleteManage: ['manage:product.product.product.delete'],
  ProductUpdateManage: ['manage:product.product.product.update'],

  // 场景
  Scene: ['view:product.scene'],
  SceneView: ['manage:product.scene.view'],
  SceneAddManage: ['manage:product.scene.add'],

  //产品展示
  ProductSearch: ['view:product.search_product'],
  ProductSync: ['view:product.product-sync'],

  // 产品看板
  ProductDashboard: ['view:product.product-dashboard'],

  //  固件看板
  firmwareDashboard: ['view:product.firmware-dashboard'],

  // 产品线
  ProductLine: ['view:product.product.product_line'],
  ProductLineManage: ['manage:product.product.product_line'],
  ProductLineAddManage: ['manage:product.product.product_line.add'],
  ProductLineDeleteManage: ['manage:product.product.product_line.delete'],
  ProductLineUpdateManage: ['manage:product.product.product_line.update'],

  // 产品关联固件
  ProductApps: ['view:product.product.relate_apps'],
  ProductAppsManage: ['manage:product.product.relate_apps'],

  // 发布策略
  PublishRule: ['view:product.product.strategy'],
  PublishRuleManage: ['manage:product.product.strategy'],

  // 产品OTA
  ProductOTA: ['view:product.product.ota'],
  ProductOTAManage: ['manage:product.product.ota'],

  // 产品固件
  ProductOTAPublic: ['view:product.product.ota.public'],
  ProductOTATest: ['view:product.product.ota.testdept'],
  ProductOTAfactory: ['view:product.product.ota.factory'],
  ProductOTAService: ['view:product.product.ota.service'],

  // 产品配置
  ProductConfig: ['view:product.product.config'],
  ProductConfigManage: ['manage:product.product.config'],

  // 产品数据权限
  ProductUser: ['view:product.product.data'],
  ProductUserManage: ['manage:product.product.data'],

  // 产品物模型
  ProductSchema: ['view:product.product.schema'],
  ProductSchemaManage: ['manage:product.product.schema'],

  // 固件
  Application: ['view:product.app.app'],
  ApplicationManage: ['manage:product.app.app'],
  ApplicationAddManage: ['manage:product.app.app.add'],
  ApplicationUpdateManage: ['manage:product.app.app.update'],
  ApplicationDeleteManage: ['manage:product.app.app.delete'],
  ApplicationImportManage: ['manage:product.app.app.import'],





  // 固件版本
  AppVersion: ['view:product.app.version'],
  AppVersionManage: ['manage:product.app.version'],

  // 固件配置
  AppConfig: ['view:product.app.config'],
  AppConfigManage: ['manage:product.app.config'],

  // 固件关联产品
  AppProduct: ['view:product.app.relate_products'],
  AppProductManage: ['manage:product.app.relate_products'],

  // 固件数据权限
  AppUser: ['view:product.app.data'],
  AppUserManage: ['manage:product.app.data'],

  // 设备搜索
  DeviceSearch: ['view:device.search'],
  DeviceManage: ['view:device.list'],

  // APK
  APK: ['view:apk'],
  APKManage: ['manage:apk'],

  // APK 版本
  APKVersion: ['view:apk.version'],
  APKVersionManage: ['manage:apk.version'],

  // APK 发布策略
  APKRule: ['view:apk.version'],
  APKRuleManage: ['manage:apk.version'],

  // I18n产品
  I18nProduct: ['view:i18n.product'],
  I18nProductManage: ['view:i18n.product'],

  // I18n固件
  I18nFirmware: ['view:i18n.app'],
  I18nFirmwareManage: ['manage:i18n.app'],

  // I18n APP
  I18nApk: ['view:i18n.apk'],
  I18nApkManage: ['manage:i18n.apk'],

  // 语言管理
  I18nLang: ['view:i18n.lang'],
  I18nLangManage: ['manage:i18n.lang'],

  // 组织页面权限项
  OrgPage: ['view:admin.organization'],
  // 角色页面权限项
  RolePage: ['view:admin.role'],

  // 升级记录
  RecordX5: ['view:update_record.x5'],

  // OTA审批
  ReviewWoTA: ['view:audit.ota_approval'],
  ReviewWoTAAll: ['view:audit.ota_approval_all'],


  // 下载按钮管理
  DownLoadManage: ['manage:button-display-on'],
}
